<template lang="pug">
div.box
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )

    receipt(ref="receipt", id="voided-receipt")
</template>
<script>
import receiptMixin from '../../mixins/receipt';
export default {
    mixins: [receiptMixin],

    data: function() {
        var that = this;
        return {
            transaction: null,
            tableName: 'VUETABLE_VOIDEDSALES',
            columns: [
                'voided_at',
                'settled_date',
                'sequence_number',
                'outlet_name',
                'total_amount',
                'table_name',
                'pax',
                'voider',
                'void_remarks',
                'cashier',
            ],
            options: {
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until'],
                headings: {
                    settled_date: 'Receipt Date',
                    sequence_number: 'Receipt No.',
                    table_name: 'Table',
                    outlet_name: 'Outlet',
                    voider: 'Voided by',
                    void_remarks: 'Void Reason',
                },
                texts: {
                    title: 'Voided Receipts',
                    description: 'Shows list of voided receipts',
                },
                templates: {
                    sequence_number: (h, row) => {
                        return this.receiptNumberFormat(row);
                    },
                    settled_date: (h, row) => {
                        return this.receiptDateFormat(row.settled_date);
                    },
                    voided_at: (h, row) => {
                        return this.receiptDateFormat(row.voided_at);
                    },
                    total_amount: (h, row) => {
                        return numeral(parseFloat(row.total_amount)).format();
                    },
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: row => {
                    this.showReceipt(row.id);
                },
                pdf_url: Laroute.route(
                    'franchise.report.voidedsales.exportAsFile',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.voidedsales.exportAsFile',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.voidedsales.exportAsFile',
                    { type: 'XLSX' },
                ),
            },
        };
    },
    computed: {
        datatableUrl() {
            return Laroute.route('franchise.report.voidedsales.index');
        },
    },
    methods: {
        refresh() {
            this.$refs.datatable.getData();
        },

        showReceipt(transaction_id) {
            this.$refs.receipt.$emit('show-receipt', transaction_id);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/voided/vuetable_voided.vue